import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { ProductActions, ProductSearchService, SearchConfig, StateWithProduct } from '@spartacus/core'

@Injectable({
  providedIn: 'root'
})
export class MbProductSearchService extends ProductSearchService {

  constructor (protected store: Store<StateWithProduct>) {
    super (store)
  }

  search (query: string | undefined, searchConfig?: SearchConfig): void {
    this.store.dispatch(
      new ProductActions.SearchProducts({
        queryText: query || '',
        searchConfig: searchConfig
      })
    )
  }

}
